'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoCanceladoCtrl', function ($scope) {
        // classe para animação da view
        $scope.pageClass = 'page-cancelado';

    });
